import { dehydrate } from '@tanstack/react-query'
import { getProps } from 'ssr/getProps'
import { runWithAmplifyServerContext, serverClient } from 'web-amplify/server'

import { searchTagQuery } from '~map-tags/api/searchTags'
import { getSearchTagsQueryKey, limit } from '~map-tags/queries/useSearchTags'
import { Search_Tags_Sort } from '~map-tags/types/__generated/gql/graphql'

export const fn = async (context, client) => {
  const { query } = context

  const page = Number(context?.query?.page) || 1

  const variables = {
    from: (page - 1) * limit,
    size: limit,
    query: query?.query || '',
    sort: query?.sort || Search_Tags_Sort.Popular
  }

  const { data } = (await runWithAmplifyServerContext({
    nextServerContext: { request: context.req, response: context.res },
    operation: async (ctx) => {
      return serverClient.graphql(ctx, {
        query: searchTagQuery,
        variables
      })
    }
  })) as any

  await client.prefetchQuery({
    queryKey: getSearchTagsQueryKey(variables),
    queryFn: () => data.searchTags
  })

  const { total = 0 } = client.getQueryData(
    getSearchTagsQueryKey(variables)
  ) as {
    total?: number
  }

  const hasNextPage = total > page * limit

  return {
    props: {
      dehydratedState: dehydrate(client),
      page,
      hasNextPage
    }
  }
}

export const getServerSideProps = getProps(fn)
